export const fragmentShader =/* glsl */ `
varying vec2 vUv;
uniform float uSpeed;
uniform float uTime;
uniform vec2 uFade;
uniform vec3 uColor;
uniform int uNumLines;
uniform float uOffset;
uniform float ulength;
uniform float uReverse;

void main() {
    vec3 color = uColor;
    float s = 0.0;
    float v = 0.0;
    float alpha = 0.0;
    float maxAlpha = 0.0; 

    s = (-uTime * uSpeed) / ulength;
    s = mod(s, 1.0);

    float direction = (uReverse == 1.0) ? 1.0 : -1.0;
    float numLinesFloat = float(uNumLines);
    float baseGap = 1.0 / numLinesFloat; 
    
    float dynamicLength = min(uFade.y, baseGap * 0.7); 
    
    float widthFactor = smoothstep(0.1, 0.5, abs(vUv.y - 0.5));
    
    for (int i = 0; i < uNumLines; i++) {
        float start = float(i) / numLinesFloat;
        start += uOffset;
        v = vUv.x * direction + start;

        float d = mod((v + s), 1.0);
        
        if (d <= dynamicLength) {
            float tempAlpha = smoothstep(uFade.x, dynamicLength, d);
            maxAlpha = max(maxAlpha, tempAlpha);
        }
    }
    
    alpha = maxAlpha * widthFactor;

    if (alpha < 0.0001) {
        discard;
    }

    gl_FragColor = vec4(color, alpha);
}
   `